import { EmptyState } from '@/components/ui/EmptyState'
import { Spinner } from '@/components/ui/Spinner'
import { useUrlFilters } from '@/hooks/useUrlFilters'
import { Box, Heading, HStack, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ActivityLogDetail } from '../components/ActivityLogDetail'
import { ActivityLogsFilters } from '../components/ActivityLogsFilters'
import { ActivityLogsTable } from '../components/ActivityLogsTable'
import { useActivityLogs } from '../hooks/useActivityLogs'

export function ActivityLogsList() {
  const { t } = useTranslation()
  const [selectedId, setSelectedId] = useState(null)
  const { filters, updateFilters, handlePaginationChange, handleSortingChange } = useUrlFilters({
    search: '',
    action: '',
    log_type: '',
    actor: '',
    page: 1,
    page_size: 20,
    ordering: '-created_at',
  })
  const params = {
    page: filters.page,
    page_size: filters.page_size,
    ordering: filters.ordering,
    ...(filters.search && { search: filters.search }),
    ...(filters.action && { action: filters.action }),
    ...(filters.log_type && { log_type: filters.log_type }),
    ...(filters.actor && { actor: filters.actor }),
  }
  const { data, isLoading, error } = useActivityLogs(params)
  const logs = data?.data || []
  const totalCount = data?.meta?.pagination?.total_count || 0
  const pageCount = Math.max(1, Math.ceil(totalCount / filters.page_size))
  const sorting = filters.ordering ? [{
    id: filters.ordering.startsWith('-') ? filters.ordering.slice(1) : filters.ordering,
    desc: filters.ordering.startsWith('-'),
  }] : []

  if (isLoading) return <Spinner fullScreen />
  if (error) {
    return <EmptyState title={t('audit.title')} description={error.message || t('audit.loadError')} />
  }

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <HStack justify="space-between" flexWrap="wrap" gap={4}>
          <Heading size="lg" color="text.primary">{t('audit.title')}</Heading>
        </HStack>
        <ActivityLogsFilters
          filters={filters}
          onFiltersChange={updateFilters}
          onReset={() => updateFilters({ search: '', action: '', log_type: '', actor: '', page: 1, ordering: '-created_at' })}
        />
        <ActivityLogsTable
          data={logs}
          isLoading={isLoading}
          pageCount={pageCount}
          totalCount={totalCount}
          pagination={{ pageIndex: filters.page - 1, pageSize: filters.page_size }}
          sorting={sorting}
          onPaginationChange={handlePaginationChange}
          onSortingChange={handleSortingChange}
          onSelect={setSelectedId}
        />
      </VStack>
      <ActivityLogDetail id={selectedId} isOpen={Boolean(selectedId)} onClose={() => setSelectedId(null)} />
    </Box>
  )
}

export default ActivityLogsList
